import { FC, memo, useCallback } from 'react';

import clsx from 'clsx';

import { ListItemAction, ListItemProps, ReportSaveMode } from '@/types';

import styles from './styles.module.scss';

import EditIcon from '@/assets/icons/edit.svg?react';
import RemoveIcon from '@/assets/icons/remove.svg?react';

export const ListItem: FC<ListItemProps> = memo((props) => {
  const { onItemClick, isSubmitting, ...listItemData } = props;
  const { hasBeenSubmitted, name, creditUnionsCount, saveMode } = listItemData;

  const handleViewList = useCallback(() => {
    onItemClick(ListItemAction.view, listItemData);
  }, [onItemClick, listItemData]);

  const handleDeleteItem = useCallback(() => {
    onItemClick(ListItemAction.delete, listItemData);
  }, [onItemClick, listItemData]);

  const handleEditList = useCallback(() => {
    onItemClick(ListItemAction.edit, listItemData);
  }, []);

  const handleSubmitOutreach = useCallback(() => {
    onItemClick(ListItemAction.submit, listItemData);
  }, []);

  return (
    <div className={styles.listContainer}>
      <div className={styles.listHeader}>
        <h3 className={styles.listTitle}>{name}</h3>

        <div className={styles.listActions}>
          {saveMode === ReportSaveMode.Configuration && !hasBeenSubmitted && (
            <button className={clsx(styles.button, styles.editBtn)} type="button" onClick={handleEditList}>
              <EditIcon /> Edit
            </button>
          )}

          <button className={clsx(styles.button, styles.deleteBtn)} type="button" onClick={handleDeleteItem}>
            <RemoveIcon /> Delete
          </button>
        </div>
      </div>

      <div className={styles.listInfo}>
        <div className={styles.listInfoLeftside}>
          <span className={styles.unionsCount}>{creditUnionsCount}</span>
          <span className={styles.cuDescription}>
            {saveMode === ReportSaveMode.CreditUnion ? 'Static' : 'Dynamic'} list
          </span>
        </div>

        <div className={styles.listInfoRightside}>
          <button
            type="button"
            disabled={!creditUnionsCount}
            className={clsx(styles.button, styles.viewListBtn)}
            onClick={handleViewList}
          >
            View List
          </button>

          <button
            type="button"
            className={clsx(styles.button, styles.submitOutreachBtn)}
            onClick={handleSubmitOutreach}
            disabled={hasBeenSubmitted || !creditUnionsCount || isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : hasBeenSubmitted ? 'Submitted' : 'Submit for Outreach'}
          </button>
        </div>
      </div>
    </div>
  );
});

ListItem.displayName = 'ListItem';
